module.exports = __webpack_public_path__ + "site/img/65.ef47edf0.jpg";